export default "__VITE_ASSET__9e4d290e__"